import axiosConfig from '@/sso/axios-config'

//未出数航线分析数据查询
export async function list(query) {
  return await axiosConfig.service({
    url: '/noRouteAnalysis/list',
    method: 'post',
    data: query,
  })
}
